import "./index.css";
import Login from "./components/Login/Login";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import SavedMaps from './components/SavedMaps/SavedMaps';

export default function App() {

		useEffect(() => {
			const handleTabClose = event => {
				event.preventDefault();
				return (event.returnValue = 'Are you sure you want to exit?');
			};
	
			window.addEventListener('beforeunload', handleTabClose);
	
			return () => {
				window.removeEventListener('beforeunload', handleTabClose);
			};
		});

		return (
			<BrowserRouter>
				<Routes>
					<Route path="/" element={<Login />} />
					<Route path="/saved-maps" element={<SavedMaps />} />
				</Routes>
			</BrowserRouter>
		)
}
